import { render, staticRenderFns } from "./quiz-users.vue?vue&type=template&id=4ec72992"
import script from "./quiz-users.vue?vue&type=script&lang=js"
export * from "./quiz-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports